import { AsyncStoreItem } from '@lib';
import { PostFlightsSearchFlightsResponse } from 'src/sdk_checkin';

/**
 * GetFlightsResult model
 */
export interface GetFlightsResultModel {
  model: PostFlightsSearchFlightsResponse | null;
}

/**
 *  model details
 */
export interface GetFlightsResultStateDetails extends AsyncStoreItem {}

/**
 * GetFlightsResult store state
 */
export interface GetFlightsResultState extends GetFlightsResultStateDetails, GetFlightsResultModel {}

/**
 * Name of the GetFlightsResult Store
 */
export const GET_FLIGHTS_RESULT_STORE_NAME = 'getFlightsResult';

/**
 * GetFlightsResult Store Interface
 */
export interface GetFlightsResultStore {
  /** GetFlightsResult state */
  [GET_FLIGHTS_RESULT_STORE_NAME]: GetFlightsResultState;
}
